import moment from 'moment-timezone'
window.moment = moment



// WEBPACK FOOTER //
// ./src/core/utils/moment-setup.js